import React from 'react';
import { ModalContentType, SitecoreFormContentType, SitecoreTrialContentType } from '../types/index';
// https://kentcdodds.com/blog/how-to-use-react-context-effectively
export const ContentContext = React.createContext({} as SitecoreFormContentType);

export const TrialContentContext = React.createContext({} as SitecoreTrialContentType);

export const ModalContentContext = React.createContext({} as ModalContentType);
